<template>
    <div>
        <el-breadcrumb separator-class="el-icon-arrow-right" style="margin-left: 15px;">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>入库维护</el-breadcrumb-item>
            <el-breadcrumb-item>入库管理</el-breadcrumb-item>
        </el-breadcrumb>
        <el-card style="height: 100%;">
            <el-row :gutter="0">
                <el-col :span="6">
                    <el-input placeholder="请输入查询内容" v-model="queryInfo.query" class="input-with-select" clearable
                        style="width:300px " @clear="getRukuList" @change="getRukuList">
                        <el-button slot="append" icon="el-icon-search" @click="getRukuList"></el-button>

                    </el-input> <el-button type="primary" @click="rukuAdd" v-if="xiugai_type == 1">入库</el-button>
                    <el-button type="primary" @click="chukuAdd" v-if="false">出库</el-button>
                </el-col>
                <el-col :span="8">
                    <el-button type="primary" @click="get_product_add" v-if="false">出库清单</el-button>
                </el-col>
                <el-col :span="10" style="text-align: right;">
                    <el-button type="primary" @click="handleExport()">导出电子表格</el-button>
                </el-col>
            </el-row>
            <el-row :gutter="0" class="el_row_two">
                <el-col :span="24">
                    <el-table :data="productList" style="width: 100%" border stripe id="report">
                        <el-table-column type="expand">
                            <template slot-scope="scope">
                                <el-table :data="scope.row.list" stripe>
                                    <el-table-column width="80" label="序号"> <template slot-scope="scope">{{ scope.$index
                                    }}</template>
                                    </el-table-column>
                                    <el-table-column prop="pro_uid" label="商品序号" width="200"> </el-table-column>
                                    <el-table-column prop="pro_name" label="商品名称" width="200"> </el-table-column>
                                    <el-table-column label="商品类别" width="300">
                                        <template slot-scope="scope">{{ scope.row.leixing01 }}:{{ scope.row.leixing02 }}:{{
                                            scope.row.leixing03 }}:{{ scope.row.leixing04 }}</template>
                                    </el-table-column>
                                    <el-table-column prop="pro_count" label="商品数量" show-overflow-tooltip>
                                    </el-table-column>
                                    <el-table-column prop="pro_kuwei" label="库位号" show-overflow-tooltip>
                                    </el-table-column>
                                </el-table>
                            </template>
                        </el-table-column>
                        <el-table-column prop="uid" label="序号" width="60"></el-table-column>
                        <el-table-column prop="ruku_bianhao" label=" 编号"></el-table-column>
                        <el-table-column prop="ruku_date" label="时间"></el-table-column>
                         <el-table-column prop="qiye_bianhao" label="编号"></el-table-column>
                          <el-table-column prop="qiye_name" label="门店"></el-table-column>
                        <!-- <el-table-column label="操作">
                            <template v-slot="scope">
                                {{ scope.row.ruku_bianhao }}
                                <el-button @click="kucun_ruku_show(scope.row.uid, scope.row.ruku_bianhao)" type="primary"
                                    plain style="margin-left: 20px;">查看明细</el-button>
                            </template>
                        </el-table-column> -->

                    </el-table>
                </el-col>
            </el-row>

            <!-- 分页 -->
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page.sync="queryInfo.pageNum" :page-sizes="[10, 50]" :page-size="queryInfo.pageSize"
                layout="total, sizes, prev, pager, next, jumper" :total="total">
                <!--分页组件，其中handleSizeChange 条数下拉触发事件，  handleCurrentChange  选择分页出发事件 currentPage2 当前页绑定 page-sizes 下拉显示列表 page-size 每页多少条绑定 layout 显示分页的元素 total 合计条数绑定  -->
            </el-pagination>
            <!-- 添加客户部分 -->
            <el-dialog title="入库" :visible.sync="rukuDialogVisible" width="90%" @close="addDoalogClosed">
                <rukuAdd @ruku_addClose="ruku_addClose" ref="rukuAddRef"> </rukuAdd>
            </el-dialog>
            <el-dialog title="入库明细" :visible.sync="rukuShowDialogVisible" width="90%" @close="addDoalogClosed">
                <rukuShow :rukudanUid="rukudanUid" :rukudanBianhao="rukudanBianhao"> </rukuShow>
            </el-dialog>
            <el-dialog title="出库" :visible.sync="chukuDialogVisible" width="90%" @close="addDoalogClosed">
                <chukuDo> </chukuDo>
            </el-dialog>
        </el-card>
    </div>
</template>
<script>
import { checkMobileTest, checkSfzId } from './config/validator'
import exportExcel from './config/exportExcel'
// import rukuDo from './module/ruku_do.vue'
import rukuShow from './module/ruku_show.vue'
import rukuAdd from './module/ruku_add.vue'
// import chukuDo from './module/chuku_do.vue'
export default {
    components: {
        // rukuDo: rukuDo,
        // chukuDo: chukuDo,
        rukuAdd: rukuAdd,
        rukuShow: rukuShow

    },
    props: ['xiugai_type', 'qiye_uid', 'show_type'], // xiugai_type 1  操作  2 显示 qiye_uid qiye_uid  企业uid ，显示模式show_type 全部显示，只显示制定企业uid部分
    data() {
        return {
            rukuDialogVisible: false,
            chukuDialogVisible: false,
            rukuShowDialogVisible: false,
            chukuShowDialogVisible: false,
            chukudan_bianhao: '',
            kucunAddData: [],
            kucunAddData_proUid: [],
            rukudanUid: 0,
            rukudanBianhao: '',

            // 获取用户列表参数
            queryInfo: {
                C_type: 'get_list_more',
                C_table_name: 'ruku_list_more',
                query: '',
                pageNum: 1,
                pageSize: 10,
                CI_canshu01: this.show_type,
                CI_canshu02: 0
            },
            productList: [],
            //  recordCount: 0,
            total: 0,
            addForm: {
                C_type: 'product_add',
                pro_bianhao: '',
                pro_xinghao: '',
                pro_price_shichang: 0,
                pro_price_huiyuan: 0,
                pro_price_pifa: 0,
                pro_price_gaoji: 0,
                pro_name: '',
                pro_chandi: '',
                pro_xilie: '',
                pro_type: '',
                pro_level: 1,
                pro_memo: ''
            },

            // 表单规则项
            addFormRules: {

            },

            editFormRules: {

            }
        };
    },
    created() {
        this.getRukuList()
        // this.chukudan_bianhao_get()
    },
    methods: {
        handleExport() {
            exportExcel('report', '导出.xlsx')
        },
        rukuDoalogClosed() {
            this.$refs.rukuAddRef.closeRuku()
        },
        rukuAdd() {
            this.rukuDialogVisible = true
        },
        chukuAdd() {
            this.chukuDialogVisible = true
        },
        addDoalogClosed() {
            this.getRukuList()
        },
        ruku_addClose() {
            this.rukuDialogVisible = false
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        kucun_ruku_show(rukudanUid, rukudanBianhao) {
            this.rukuShowDialogVisible = true
            this.rukudanUid = rukudanUid
            this.rukudanBianhao = rukudanBianhao
        },
        kucun_chuku_show() {
            this.chukuShowDialogVisible = true
        },
        async getRukuList() {
            const { data: res } = await this.$http.get('get_api', {
                params: this.queryInfo
            });
            console.log(JSON.parse(res.data)[0].dataList)
            this.productList = JSON.parse(res.data)[0].dataList

            if (!this.productList) return;
            this.productList.forEach(function (item) {
                item.yong_flag = item.yong_flag === 1;
            });

            this.total = JSON.parse(res.data)[0].total;

            // console.log(this.total)
        },
        //  分页第一项下拉触发

        handleSizeChange(newSize) {
            this.queryInfo.pageSize = newSize;
            this.getRukuList();
        },
        // 选择页数触发
        handleCurrentChange(newPage) {
            this.queryInfo.pageNum = newPage;
            this.getRukuList();
        }
    }
}
</script>
<style lang="less" scoped>
.card_two {
    margin-top: 30px;
    box-shadow: none !important;
    background-color: #f2f6fc;
}

.el_row_two {
    margin-top: 30px;
}
</style>
